<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="800"
      scrollable
      persistent
    >
      <PublicationsForm
        :publication="editedPublication"
        :errors="publicationValidationErrors"
        :disabled="savingPublication"
        @clear:errors="clearPublicationValidationErrors"
        @cancel="$router.push({ name: 'publications' })"
        @save="onSave"
        @preview="onPreview"
        @upload:image="onImageUpload"
        @delete:image="onImageDelete"
        @select:file="onFileSelect"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { mapErrorsToInputs } from '@/util/forms.js';
import PublicationsForm from '../../components/PublicationsForm';
import store from '../../store';

export default {
  name: 'EditPublications',

  components: { PublicationsForm },

  computed: mapState('publications', [
    'editedPublication',
    'publicationValidationErrors',
    'savingPublication',
  ]),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('publications/editPublication', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'publications' });
      });
  },

  methods: {
    ...mapActions('publications', [
      'updatePublication',
      'clearPublicationValidationErrors',
      'uploadPublicationsImage',
      'deletePublicationsImage',
    ]),
    ...mapMutations('publications', ['SET_PUBLICATION_VALIDATION_ERRORS']),

    onFileSelect(file) {
      this.$set(this.editedPublication, 'file', file[0]);
    },

    onImageUpload(image, type, modelType, modelId) {
      this.uploadPublicationsImage({
        image,
        type,
        modelType,
        modelId,
      }).catch((err) => {
        const errors = mapErrorsToInputs(err);
        this.SET_PUBLICATION_VALIDATION_ERRORS({ ...this.publicationValidationErrors, ...errors });
        throw err;
      });
    },

    onImageDelete(image) {
      this.deletePublicationsImage(image);
    },

    onSave(publication) {
      this.updatePublication(publication).then(() => {
        this.$router.push({ name: 'publications' });
      });
    },

    onPreview(publication) {
      this.updatePublication(publication).then(() => {
        window.open(this.$previewBackendUrl(`leidiniai/${publication.id}?`));
      });
    },
  },
};
</script>

<style scoped></style>
